










































import {Component, Prop, Vue, Ref, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';
import ChartColumnBar from '@/components/lfs/NewStatistics/Elements/ChartColumnBar.vue';
import ContactsCategory from '@/components/lfs/NewStatistics/GeneralDashboard/ContactsCategory.vue'
import ContactsInterest from '@/components/lfs/NewStatistics/GeneralDashboard/ContactsInterest.vue'

import {sortBy} from "lodash";
import {locales} from "@/helpers/locales";
import Highcharts from "highcharts";
import {colorsChart} from "@/helpers/colorsChart";


const newstatistics = namespace('newstatistics')

@Component({
  name: 'DataSurvey',
  components: {ChartColumnBar, ChangeClicker, ContactsCategory,ContactsInterest}
})
export default class DataSurvey extends Vue {
  @Prop({type: String, default: ''}) title !: string
  @Prop({type: Object, default: {}}) categoryCount !: {}
  @Prop({type: Object, default: {}}) hotLevelCount !: {}
  @Prop({type: Array, default: () => []}) protected surveyChart!: any
  @Prop({type: Boolean, default: true}) protected loading!: any
  @Prop({type: Array || null, default: []}) items!: string[]

  @Watch('loading')
  onLoad(newVal: any) {
    if (newVal) return
    // this.updateSeries()
  }

  @Watch('currentLocale', {immediate: true})
  onLocaleChanged(_: any) {
    this.updateNames()
  }
  get categories(): any {
    return {
      isNew: { title: this.$t('newstatistics.general.contacts_category.isNew'), color: '#29B450', count: null },
      none: { title: this.$t('newstatistics.general.contacts_category.none'), color: '#D2CCDD', count: null },
      exists: { title: this.$t('newstatistics.general.contacts_category.exists'), color: '#2D9CDB', count: null },
    }
  }

  get contactsCategory() {
    const cat:any = this.categoryCount
    for (let item in cat) {
      this.categories[item].count = cat[item]
    }
    return this.categories
  }

  get currentLocale() {
    return this.$i18n.locale
  }

  updateNames() {
    Highcharts.setOptions({
      lang: {
        shortMonths: locales[this.currentLocale]
      }
    })
    this.chartOptions.series[0].name = this.$t('newstatistics.v4.survey.chart.tooltip')
    this.chartOptions.yAxis.title.text = this.$t('newstatistics.v4.survey.chart.title')
  }

  width: string = '0'


  @Ref('chartContainer') readonly chartContainer!: any
  @Ref('surveyChartWrapper') readonly surveyChartWrapper!: any

  protected mounted() {
    this.$nextTick(() => {
      this.width = String(this.chartContainer.offsetWidth)
      this.chartOptions.chart.width = this.width
      this.chartOptions.chart.width = null
    })
    // setTimeout(() => this.updateSeries(), 100)
  }

  normalizeItems(items: any) {
    const sorted = items.map((ele: any, idx: number) => {
      const colorsCount = this.colors.length - 1
      if (idx > colorsCount) {
        idx = idx % colorsCount
      }
      return {
        name: ele.answerTitle,
        y: ele.count,
        count: ele.percent,
        color: this.colors[idx]
      }
    })
    return sortBy(sorted, ['y']).reverse()
  }

  protected updateSeries(): void {
    const chart: any = this.$refs.surveyChart
    chart.chart.update({
      series: [
        {
          data: this.surveyChart.map(((item: any) => [item[0] * 1000, item[1]])),
        },
      ]
    })
  }

  colors: any = colorsChart

  chartOptions: any = {
    lang: {
      shortMonths: locales[this.currentLocale]
    },
    chart: {
      type: 'areaspline',
      height: '371',
      width: null,
      style: {"fontSize": "12px"},
      backgroundColor: 'transparent',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '30',
      marginBottom: '50',
      colorCount: 50,
      lang: 'en_EN'
    },
    loading: {
      hideDuration: 1000,
      showDuration: 1000
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        const locale: string | null = localStorage.getItem('locale')!
        return '<div class="statistics-v4-tooltip">' + '<span class="statistics-v4-tooltip-title">'
          + new Date(context.x).toLocaleString(locale + '-' + locale.toUpperCase(), {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          }) +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.series.name + ' - ' + context.y + '</span></div>'
      },
    },
    xAxis: {
      type: 'datetime',
      labels: {
        overflow: 'justify'
      }
    },
    yAxis: {
      allowDecimals: false,
      title: {
        text: this.$t('newstatistics.v4.survey.chart.title'),
        style: {
          color: '#0A0A0A',
          fontSize: '14px',
          lineHeight: '16px',
          fontWeight: '400',
          fontFamily: 'Inter'
        }
      }
    },
    legend: {
      enabled: false,
    },
    plotOptions: {

    },
    series: [
      {
        data: this.surveyChart.map(((item: any) => [item[0] * 1000, item[1]])),
        name: this.$t('newstatistics.v4.survey.chart.tooltip')
      },
    ]
  }

}
